import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { ActionButtonComponent, ButtonAction } from '../../../ui-kit/action-button';
import { ProfileFacade } from '../../../store/state/administration/profile/profile.facade';

@Component({
  selector: 'lib-maps-plugin-accept',
  imports: [CommonModule, MatCardModule, ActionButtonComponent, TranslateModule],
  templateUrl: './maps-plugin-accept.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapsPluginAccept {
  buttonAction = ButtonAction;

  constructor(@Optional() private dialogRef: MatDialogRef<MapsPluginAccept>, private profileFacade: ProfileFacade) {}

  enable(): void {
    this.profileFacade.acceptMapsPlugin();
    this.dialogRef?.close();
  }

  dismiss(): void {
    this.dialogRef?.close();
  }
}
